import Header from "../common/Header";
import PageContainer from "../common/PageContainer";
import RouteProtection from "../common/RouteProtection";
import TabPage from "../common/Tab/TabPage";
import Tab from "../common/Tab/Tab";
import SearchBar from "../common/SearchBar";

import uniqid from "uniqid";
import { useState, useEffect } from "react";
import ProblemList from "./ProblemList";
import { fetchWithToken } from "../../functions/fetch";
import { sortByTime } from "../../functions/array";
import { addSearchedField } from "../../functions/problem";

const ProblemPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [notWorkingProblems, setNotWorkingProblems] = useState([]);
  const [workingProblems, setWorkingProblems] = useState([]);
  const [doneProblems, setDoneProblems] = useState([]);

  const [fetchedProblems, setFetchedProblems] = useState([]);
  const [unfilteredProblems, setUnfilteredProblems] = useState([]);
  const [filteredProblems, setFilteredProblems] = useState([]);

  const tabText = ["未處理", "處理中", "已結案"];
  const pages = [
    <ProblemList
      key={uniqid()}
      problems={filteredProblems}
      setProblems={setFetchedProblems}
    />,
    <ProblemList
      key={uniqid()}
      problems={filteredProblems}
      setProblems={setFetchedProblems}
    />,
    <ProblemList
      key={uniqid()}
      problems={filteredProblems}
      setProblems={setFetchedProblems}
    />,
  ];

  const fetchProblem = async () => {
    const res = await fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/problem`,
    );

    if (res.status === 200) {
      const problems = res.problems;
      addSearchedField(problems);
      setFetchedProblems(problems);
    } else {
      console.error(res);
    }
  };

  useEffect(() => {
    fetchProblem();
  }, []);

  // update items for searching/ showing on tab
  useEffect(() => {
    const items = [notWorkingProblems, workingProblems, doneProblems];
    setUnfilteredProblems(items[tabIndex]);
  }, [notWorkingProblems, workingProblems, doneProblems, tabIndex]);

  // classify items when first fetch/updated by user
  useEffect(() => {
    let problemsOfProgress = [[], [], []];

    fetchedProblems.forEach((problem) => {
      problemsOfProgress[Number(problem.progress)].push(problem);
    });

    problemsOfProgress = problemsOfProgress.map((arr) =>
      sortByTime(arr, "createdAt"),
    );

    setNotWorkingProblems(problemsOfProgress[0]);
    setWorkingProblems(problemsOfProgress[1]);
    setDoneProblems(problemsOfProgress[2]);
  }, [fetchedProblems]);

  return (
    <>
      <RouteProtection />
      <Header />
      <PageContainer>
        <div className="flex justify-between items-center">
          <Tab texts={tabText} tabIndex={tabIndex} setTabIndex={setTabIndex} />
          <SearchBar
            items={unfilteredProblems}
            setFunction={setFilteredProblems}
          />
        </div>
        <TabPage tabIndex={tabIndex} pages={pages} />
      </PageContainer>
    </>
  );
};

export default ProblemPage;
